import {
    getFirestore,
    collection,
    getDocs,
    updateDoc,
    doc,
    getDoc,
    Timestamp,
    deleteDoc,
    addDoc,
} from "firebase/firestore";
import { ErrorHelper } from "../helpers/ErrorHelper";
import { FireHelper } from "../helpers/FireHelper";
import { Firebase } from "../FirebaseApp";
import { toast } from "react-toastify";

export const AddressesController = {
    db: getFirestore(Firebase),

    ToFirestoreData: function (data) {
        let updatedData = {
            id: data.id,
            address: {
            street: data.street,
            number: data.number,
            complement: data.complement,
            neighborhood: data.neighborhood,
            city: data.city,
            state: data.state,
            zip: data.zip,
            },
            default_address: data.default_address,
            owner: doc(this.db, `users`, data.owner), // Reference to the users collection
            created_at: data.created_at ?? Timestamp.now(),
            updated_at: Timestamp.now(),
        };
        return FireHelper.ToFirestoreDoc(updatedData);
    },

    Insert: async function (userId, data, res) {
        try {
          const inviteRef = collection(this.db, `users/${userId}/addresses`);
          const result = await addDoc(inviteRef, this.ToFirestoreData(data));
    
          res(result.id);
        } catch (e) {
          toast(ErrorHelper.HandleMessage(e));
        }
      },

    Update: async function (userId, data, res) {
        try {
            const frankDocRef = doc(this.db, `users/${userId}/addresses`, data.id);
            await updateDoc(frankDocRef, this.ToFirestoreData(data));
        } catch (e) {
            toast(ErrorHelper.HandleMessage(e));
        }
    },

    List: async function (userId, res) {
        const querySnapshot = await getDocs(
            collection(this.db, `users/${userId}/addresses`)
        );
        const results = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
        }));
        res(results);
    },
    
  Delete: async function (userId, id) {
    await deleteDoc(doc(this.db, `users/${userId}/addresses`, id));
    return true;
  },
};
